/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../components/common/Home'),
      redirect: 'main',
      children: [
        {
          path: 'main',
          name: 'main',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/main')
        },
        {
          path: 'showDetail',
          name: 'showDetail',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/showDetail')
        },
        {
          path: 'showQuery',
          name: 'showQuery',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/ShowQuery')
        },
        {
          path: 'about',
          name: 'about',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/about')
        },
        {
          path: 'help',
          name: 'help',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/help')
        },
        {
          path: 'standard',
          name: 'standard',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/standard')
        },
        {
          path: 'literature',
          name: 'literature',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/literature')
        },
        {
          path: 'paper',
          name: 'paper',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/paper.vue')
        },
        {
          path: 'addnew',
          name: 'AddNew',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/addNewPage.vue')
        },
        {
          path: 'queryPaper',
          name: 'queryPaper',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/paperQuery.vue')
        },
        {
          path: 'meetting',
          name: 'meetting',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/meeting.vue')
        },
        {
          path: 'analyze',
          name: 'analyze',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/analyze.vue')
        },
        {
          path: 'login',
          name: 'login',
          meta: {
            keepAlive: false
          },
          component: () => import('../components/login.vue')
        },
        {
          path: 'forgetPsd',
          name: 'forgetPsd',
          meta: {
            keepAlive: false
          },
          component: () => import('../pages/forgetpsd.vue')
        },
        {
          path: 'userCenter',
          name: 'userCenter',
          meta: {
            keepAlive: true
          },
          component: () => import('../pages/userCenter.vue')
        }
      ]
    },
    {
      path: '/adminerLogin',
      name: 'adminerLogin',
      component: () => import('../components/adminerLogin.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('../pages/admin.vue'),
      beforeEnter: (to, from, next) => {
        const isAuthen = localStorage.getItem('adminerInfo')
        if (isAuthen) {
          next('/admin/mangerHome')
        } else {
          next('/adminerLogin')
        }
      },
      redirect: '/admin/mangerHome',
      children: [
        {
          path: 'mangerHome',
          name: 'mangerHome',
          component: () => import('../pages/mangerHome.vue')
        },
        {
          path: 'CreateNewLiterature',
          name: 'CreateNewLiterature',
          component: () => import('../pages/createNewLiterature.vue')
        },
        {
          path: 'LiteratureData',
          name: 'LiteratureData',
          component: () => import('../pages/LiteratureData.vue')
        },
        {
          path: 'DBPsData',
          name: 'DBPsData',
          component: () => import('../pages/DBPsData.vue')
        },
        {
          path: 'createNewDBPS',
          name: 'createNewDBPS',
          component: () => import('../pages/createNewDBPS.vue')
        },
        {
          path: 'modifyCheck',
          name: 'modifyCheck',
          component: () => import('../pages/modifyCheck.vue')
        },
        {
          path: 'userDataManager',
          name: 'userDataManager',
          component: () => import('../pages/userDataManager.vue')
        },
        {
          path: 'createUser',
          name: 'createUser',
          component: () => import('../pages/createUser.vue')
        },
        {
          path: 'addNewCheck',
          name: 'addNewCheck',
          component: () => import('../pages/addNewCheck.vue')
        }
      ]
    }
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js